export const birthType = [
    { value: 'Natural', text: 'Natural' },
    { value: 'Caesarean', text: 'Caesarean' },
    { value: 'Vacuum Extraction', text: 'Vacuum Extraction' },
    { value: 'Forceps Delivery', text: 'Forceps Delivery' }
  ];
  export const gender = [
    { value: 'Male', text: 'Male' },
    { value: 'Female', text: 'Female' },
    { value: 'Others', text: 'Others' }
  ];
  
  export const bloodGroup = [
    { value: 'A+', text: 'A+' },
    { value: 'A-', text: 'A-' },
    { value: 'B+', text: 'B+' },
    { value: 'B-', text: 'B-' },
    { value: 'AB+', text: 'AB+' },
    { value: 'AB-', text: 'AB-' },
    { value: 'O+', text: 'O+' },
    { value: 'O-', text: 'O-' }
  ];

  export const medium = [
    { value: 'English', text: 'English' },
    { value: 'Tamil', text: 'Tamil' },
    { value: 'Others', text: 'Others' }
  ];

  export const classsection = [
    { value: 'A', text: 'A' },
    { value: 'B', text: 'B' },
    { value: 'C', text: 'C' },
    { value: 'D', text: 'D' },
    { value: 'E', text: 'E' },
    { value: 'F', text: 'F' },
    { value: 'G', text: 'G' },
    { value: 'H', text: 'H' },
    { value: 'I', text: 'I' },
    { value: 'J', text: 'J' },
  ];
  
  export const studentclass = [
    { value: '9', text: '9th Standard' },
    { value: '10', text: '10th Standard' },
    { value: '11', text: '11th Standard' },
    { value: '12', text: '12th Standard' },
  ];
